import { gql } from '@apollo/client';

export const CREATE_TAG = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      id
      name
      slug
      color
      description
      positionCount
      stockPositionCount
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation UpdateTag($input: UpdateTagInput!) {
    updateTag(input: $input) {
      id
      name
      slug
      color
      description
      positionCount
      stockPositionCount
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_TAG = gql`
  mutation DeleteTag($id: ID!) {
    deleteTag(id: $id)
  }
`;

export const ASSIGN_TAGS = gql`
  mutation AssignTags($input: AssignTagsInput!) {
    assignTags(input: $input) {
      id
      name
      slug
      color
    }
  }
`;

export const REMOVE_TAGS = gql`
  mutation RemoveTags($input: RemoveTagsInput!) {
    removeTags(input: $input)
  }
`;

export const ASSIGN_STOCK_TAGS = gql`
  mutation AssignStockTags($input: AssignTagsInput!) {
    assignStockTags(input: $input) {
      id
      name
      slug
      color
    }
  }
`;

export const REMOVE_STOCK_TAGS = gql`
  mutation RemoveStockTags($input: RemoveTagsInput!) {
    removeStockTags(input: $input)
  }
`;

export const BULK_ASSIGN_TAG = gql`
  mutation BulkAssignTag($input: BulkAssignTagInput!) {
    bulkAssignTag(input: $input)
  }
`;

export const BULK_REMOVE_TAG = gql`
  mutation BulkRemoveTag($input: BulkRemoveTagInput!) {
    bulkRemoveTag(input: $input)
  }
`;
